var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',[_c('loading',{attrs:{"active":_vm.loading,"can-cancel":false,"is-full-page":true,"height":150,"width":150,"color":'#FFFF00',"background-color":'#000000',"opacity":0.5},on:{"update:active":function($event){_vm.loading=$event}}})],1):_c('div',[_c('app-form',{attrs:{"parentObject":{
      data: this.formData,
      formDataId: this.id,
      searchnew: this.search,
      pageTitle: this.pageTitle,
      pageTitleValue: this.pageTitleValue,
      errMsg: this.errMsg,
      isEdit: this.editMode,
    }},on:{"input":function($event){_vm.formData = $event},"save":_vm.saveHandler,"delete":function($event){_vm.isConfirm = !_vm.isConfirm},"new":_vm.createHandler,"error":_vm.errorHandler}}),(_vm.isErr)?_c('div',[_c('app-error',{attrs:{"parentError":{
        data: this.errMsg,
        isErr: this.isErr,
      }},on:{"closeError":function($event){_vm.isErr = $event}}})],1):_vm._e(),(_vm.isConfirm)?_c('div',[_c('app-confirm',{attrs:{"parentObject":{
        pageTitleValue: this.pageTitleValue,
        isConfirm: this.isConfirm,
      }},on:{"confirm":function($event){return _vm.deleteHandler($event)},"cancelConfirm":function($event){_vm.isConfirm = !_vm.isConfirm}}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }